/*
 * @Author: your name
 * @Date: 2021-09-26 21:29:54
 * @LastEditTime: 2022-05-13 11:11:19
 * @LastEditors: lsr lsr@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \h5-vip\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 路由懒加载
// component: () => import ('文件路径')


const router = new Router({
	mode: 'history', //去掉#号
	routes: [{
		path: "/",
		name: "registered",
		meta: {
			title: "加入易伙伴"
		},
		component: () =>
			import('@/pages/registered')
	}, {
		path: "/download",
		name: "download",
		meta: {
			title: "下载易伙伴App"
		},
		component: () =>
			import('../pages/download/index')
	}, {
		path: "/sysdownload",
		name: "sysdownload",
		meta: {
			title: "下载如意刷App"
		},
		component: () =>
			import('../pages/download/sysdownload')
	}, {
		path: "/jsbdownload",
		name: "jsbdownload",
		meta: {
			title: "下载聚收宝App"
		},
		component: () =>
			import('../pages/download/jsbdownload')
	}, {
		path: "/jxsdownload",
		name: "jxsdownload",
		meta: {
			title: "下载吉祥刷App"
		},
		component: () =>
			import('../pages/download/jxsdownload')
	}, {
		path: "/jxsposdownload",
		name: "jxsposdownload",
		meta: {
			title: "下载吉祥刷大POS"
		},
		component: () =>
			import('../pages/download/jxsposdownload')
	}, {
		path: "/service",
		name: "service",
		meta: {
			title: ""
		},
		component: () =>
			import('../pages/chatgpt/serviceAi')
	}, {
		path: "/agreement",
		name: "agreement",
		meta: {
			title: "隐私政策"
		},
		component: () =>
			import('@/pages/agreement')
	}, {
		path: "/userInformation",
		name: "userInformation",
		meta: {
			title: "信息核验"
		},
		component: () =>
			import('@/pages/userInformation')
	}, {
		path: "/khAuthorizationAgreement",
		name: "khAuthorizationAgreement",
		meta: {
			title: "用户授权册协议"
		},
		component: () =>
			import('@/pages/agreement/khAuthorizationAgreement')
	}, {
		path: "/khRegistrationAgreement",
		name: "khRegistrationAgreement",
		meta: {
			title: "易伙伴用户注册服务协议"
		},
		component: () =>
			import('@/pages/agreement/khRegistrationAgreement')
	}, {
		path: "/qr",
		name: "qr",
		meta: {
			title: "扫码办卡"
		},
		component: () =>
			import('@/pages/qr/index')
	}, {
		path: "/articledetails",
		name: "articledetails",
		meta: {
			title: "文章详情"
		},
		component: () =>
			import('@/pages/articledetails/articledetails')
	}, {
		path: "/privacyPolicy",
		name: "privacyPolicy",
		meta: {
			title: "隐私政策"
		},
		component: () =>
			import('@/pages/rys/privacyPolicy')
	}, {
		path: "/jxsWill",
		name: "jxsWill",
		meta: {
			title: ""
		},
		component: () =>
			import('@/pages/HumanFace/jxsWill')
	}, {
		//聚收宝隐私政策
		path: "/jsbprivacyPolicy",
		name: "jsbprivacyPolicy",
		meta: {
			title: "隐私政策"
		},
		component: () =>
			import('@/pages/jsb/privacyPolicy')
	}, {
		path: "/jsbkhRegistrationAgreement",
		name: "khRegistrationAgreement",
		meta: {
			title: "聚收宝用户注册服务协议"
		},
		component: () =>
			import('@/pages/jsb/khRegistrationAgreement')
	}, {
		path: "/HumanFace",
		name: "HumanFace",
		meta: {
			title: "信息采集"
		},
		component: () =>
			import('@/pages/HumanFace/HumanFace')
	}, {
		path: "/willingness",
		name: "willingness",
		meta: {
			title: "意愿核身"
		},
		component: () =>
			import('@/pages/HumanFace/willingness')
	}, {
		path: "/will",
		name: "will",
		meta: {
			title: "意愿核身"
		},
		component: () =>
			import('@/pages/HumanFace/will')
	}, {
		path: "/kxsWill",
		name: "kxsWill",
		meta: {
			title: "意愿核身"
		},
		component: () =>
			import('@/pages/HumanFace/kxsWill')
	}, ]
})


router.beforeEach((to, from, next) => { //beforeEach是router的钩子函数，在进入路由前执行
	if (to.meta.title) { //判断是否有标题
		document.title = to.meta.title
	}
	next() //执行进入路由，如果不写就不会进入目标页
})
export default router